
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bLtXM", function(module, exports) {

$parcel$export(module.exports, "ContentHeaderPresenceComponent", () => $1e82291b1be231ce$export$a8d99186a74b60f6);
$parcel$export(module.exports, "ContentHeaderPresence", () => $1e82291b1be231ce$export$52baa28b583c9835);
/** @graphql cc **/ 
var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $d2LG0 = parcelRequire("d2LG0");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $3jwuS = parcelRequire("3jwuS");

var $jXpbL = parcelRequire("jXpbL");

var $de2j9 = parcelRequire("de2j9");

var $ln0hx = parcelRequire("ln0hx");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $cLo2u = parcelRequire("cLo2u");

var $7Sm4c = parcelRequire("7Sm4c");

var $efvKr = parcelRequire("efvKr");

var $lkApp = parcelRequire("lkApp");

var $9VtwR = parcelRequire("9VtwR");

var $4jksU = parcelRequire("4jksU");

var $lx2Vu = parcelRequire("lx2Vu");
const $1e82291b1be231ce$var$createDefaultParticipant = ({ presenceId: presenceId, activity: activity, user: user, isGuest: isGuest })=>{
    const sessions = {
        [(0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID)]: {
            activity: activity
        }
    };
    const usablePresenceId = user?.id ?? presenceId;
    return {
        id: usablePresenceId,
        userId: user?.id ?? 'unidentified',
        presenceId: usablePresenceId,
        name: user?.displayName ?? '',
        src: user?.photos?.[0]?.value ?? '',
        isCurrentUser: true,
        isGuest: isGuest,
        sessions: sessions
    };
};
const $1e82291b1be231ce$export$a8d99186a74b60f6 = ({ collaborators: collaborators, contentId: contentId, contentType: contentType, isViewMode: isViewMode, analyticSource: analyticSource })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const isEditPage = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { data: userData, error: userQueryError } = (0, $diswb.useQuery)((0, $d2LG0.default)`query ContentHeaderPresenceUserQuery{user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}}`);
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $gwFzn.useRef)(presenceId);
    let contentMode = 'view';
    if (isLivePage) contentMode = 'live';
    else if (isEditPage) contentMode = 'edit';
    const activity = contentMode === 'edit' || contentMode === 'live' && (isLiveEditMode || !isViewMode) ? 'editor' : 'viewer';
    const { data: settingData, error: settingsQueryError } = (0, $diswb.useQuery)((0, $d2LG0.default)`query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId spaceKey:$spaceKey){isEnabledOnContentView}}`, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !(0, $9wGTI.fg)('confluence_team_presence_enable_on_view') || contentType === 'whiteboard' || contentMode !== 'view'
    });
    const error = userQueryError || settingsQueryError;
    const isAnonymousBlockedOnView = !isLoggedIn && (0, $9wGTI.fg)('confluence_team_presence_prevent_anonymous_on_view');
    const isSettingEnabledOnView = (0, $gwFzn.useCallback)(()=>{
        if (contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_team_presence_whiteboard')) return true;
        else return settingData?.confluence_teamPresenceContentSetting?.isEnabledOnContentView === true;
    }, [
        contentType,
        settingData
    ]);
    if (!contentType) return null;
    if (error) {
        experienceTracker.fail({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            error: error
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    }
    if (contentMode === 'view') {
        if (!isSettingEnabledOnView()) {
            experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
                reason: `Real-time visibility is disabled on view mode`
            });
            return null;
        }
        if (isAnonymousBlockedOnView) {
            experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
                reason: `Real-time visibility is disabled on view mode for anonymous users`
            });
            return null;
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lkApp.PresenceStoreContainer), {
        participant: $1e82291b1be231ce$var$createDefaultParticipant({
            presenceId: presenceIdRef.current,
            activity: activity,
            user: userData?.user,
            isGuest: isGuest
        })
    }, contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_team_presence_whiteboard') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lx2Vu.CanvasPresence), {
        collaborators: collaborators,
        contentId: contentId,
        contentType: contentType,
        analyticSource: analyticSource
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jksU.Presence), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        activity: activity,
        analyticSource: analyticSource
    }));
};
const $1e82291b1be231ce$export$52baa28b583c9835 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).COLLABORATION_PRESENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabPresenceStateContainer), {
        scope: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1e82291b1be231ce$export$a8d99186a74b60f6, props)));
};

});
parcelRegister("lkApp", function(module, exports) {

$parcel$export(module.exports, "usePresenceStoreActions", () => $2960af57d9597263$export$afdb9ee4b69111fa);
$parcel$export(module.exports, "useParticipants", () => $2960af57d9597263$export$23e4fe06e7659b53);
$parcel$export(module.exports, "useTotalCount", () => $2960af57d9597263$export$4af6cc58a9a6c026);
$parcel$export(module.exports, "useTransformedParticipants", () => $2960af57d9597263$export$5a5a291828ecb5e4);
$parcel$export(module.exports, "useActiveTelepointerBySessions", () => $2960af57d9597263$export$f1a08937c1f9340b);
$parcel$export(module.exports, "PresenceStoreContainer", () => $2960af57d9597263$export$f642eede20cf74c0);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $9wGTI = parcelRequire("9wGTI");

var $kCM9P = parcelRequire("kCM9P");

var $9VtwR = parcelRequire("9VtwR");
const $2960af57d9597263$var$updateParticipantSession = (activity, participant, sessionId)=>{
    return {
        ...participant,
        sessions: {
            ...participant.sessions,
            [sessionId]: {
                activity: activity ?? 'viewer'
            }
        }
    };
};
const $2960af57d9597263$var$mapAnonymousParticipant = (presenceId, sessions)=>{
    return {
        id: presenceId,
        userId: 'unidentified',
        presenceId: presenceId,
        name: '',
        src: '',
        isGuest: false,
        sessions: sessions
    };
};
// yes, all this is hella messy right now, will be refactoring and moving out of a store
const $2960af57d9597263$var$PresenceStore = (0, $4ZoIm.createStore)({
    initialState: {
        participants: new Map(),
        totalCount: 0,
        telepointers: new Map()
    },
    actions: {
        add: (participant)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                // can't be null in confluence, ultimately is the userId for logged in users and presenceId for anonymous
                const { presenceId: id } = participant;
                const currentParticipants = new Map(participants);
                if (id) {
                    const previousParticipant = currentParticipants.get(id);
                    const entry = {
                        id: id,
                        userId: participant.userId,
                        presenceId: participant.presenceId,
                        name: participant.name,
                        isGuest: participant.isGuest,
                        isCurrentUser: Boolean(previousParticipant?.isCurrentUser),
                        src: participant.avatar,
                        sessions: {
                            ...previousParticipant?.sessions,
                            [participant.sessionId]: {
                                activity: participant.presenceActivity ?? 'viewer'
                            }
                        }
                    };
                    currentParticipants.set(id, entry);
                    setState({
                        participants: currentParticipants
                    });
                } else // eslint-disable-next-line no-console
                console.error("presenceId is null for participant when it shouldn't be for ", participant);
            },
        // @deprecated, will be replaced with add
        addParticipantFromCollabSocket: (participant)=>({ getState: getState, setState: setState })=>{
                const { participants: participants, totalCount: totalCount } = getState();
                // can't be null in confluence, ultimately is the userId for logged in users and presenceId for anonymous
                const { presenceId: id } = participant;
                const currentParticipants = new Map(participants);
                if (id) {
                    const previousParticipant = currentParticipants.get(id);
                    const entry = {
                        ...participant,
                        // need to determine if entry
                        isCurrentUser: previousParticipant?.isCurrentUser ?? false,
                        id: id,
                        src: participant.avatar,
                        sessions: {
                            ...previousParticipant?.sessions,
                            [participant.sessionId]: {
                                activity: participant.presenceActivity ?? 'viewer'
                            }
                        }
                    };
                    currentParticipants.set(id, entry);
                    if (!previousParticipant) setState({
                        participants: currentParticipants,
                        totalCount: totalCount + 1
                    });
                    else setState({
                        participants: currentParticipants
                    });
                }
            },
        // @deprecated, will be replaced with add
        addParticipant: (participant, participantsToHydrateRef)=>({ getState: getState, setState: setState })=>{
                const { participants: participants, totalCount: totalCount } = getState();
                const joinedParticipant = participant;
                const key = joinedParticipant.presenceId ?? joinedParticipant.userId;
                const hydratedParticipant = participants.get(key);
                if (hydratedParticipant) {
                    const currentParticipants = new Map(participants);
                    currentParticipants.set(key, $2960af57d9597263$var$updateParticipantSession(joinedParticipant.presenceActivity, hydratedParticipant, joinedParticipant.sessionId));
                    setState({
                        participants: currentParticipants
                    });
                } else {
                    const { sessionId: sessionId, presenceActivity: activity, userId: userId } = joinedParticipant;
                    const previousEntry = participantsToHydrateRef.current[key];
                    const entry = {
                        [sessionId]: {
                            activity: activity ?? 'viewer'
                        }
                    };
                    const hasPreviousEntry = !!previousEntry?.sessions;
                    // we can run into cases where we have multiple sessions for the same user, but have yet to fully hydrate them
                    // so ensure our sessions list is up-tp-date
                    const sessions = hasPreviousEntry ? {
                        ...previousEntry?.sessions,
                        ...entry
                    } : entry;
                    participantsToHydrateRef.current[key] = {
                        ...joinedParticipant,
                        sessions: sessions
                    };
                    if (!hasPreviousEntry) setState({
                        totalCount: totalCount + 1
                    });
                    // We can skip hydration for anonymous users, perhaps I should bump this higher up to short circuit
                    // more of this logic ... this is getting quite messy
                    const isAnonymous = userId === 'unidentified';
                    if (isAnonymous) {
                        const currentParticipants = new Map(participants);
                        currentParticipants.set(key, $2960af57d9597263$var$mapAnonymousParticipant(key, sessions));
                        setState({
                            participants: currentParticipants
                        });
                        delete participantsToHydrateRef.current[key];
                    }
                }
            },
        // @deprecated, will be replaced with add
        addHydratedParticipant: (participant, participantsToHydrateRef)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                const user = participant;
                // can't be null in confluence, ultimately is the userId for logged in users and presenceId for anonymous
                const { presenceId: id, sessions: sessions } = user;
                const userId = user?.accountId ?? 'unidentified';
                const currentParticipants = new Map(participants);
                if (id) {
                    const previousParticipant = currentParticipants.get(id);
                    const entry = {
                        id: id,
                        userId: userId,
                        src: user.avatarPath,
                        isGuest: (user.permissionType === (0, $kCM9P.SitePermissionType).EXTERNAL) ?? undefined,
                        sessions: sessions,
                        presenceId: id,
                        name: user.name,
                        isCurrentUser: user.isCurrentUser ?? false
                    };
                    let dirty = false;
                    if (!previousParticipant) {
                        currentParticipants.set(id, entry);
                        dirty = true;
                    }
                    // still triggers a state change even if object hasn't changed,
                    // so helping out a bit to prevent a extra re-renders
                    if (dirty) setState({
                        participants: currentParticipants
                    });
                    delete participantsToHydrateRef.current[id];
                }
            },
        // @deprecated, will be replaced with remove
        removeParticipant: (sessionId, participantsToHydrateRef)=>({ getState: getState, setState: setState })=>{
                const { participants: participants, totalCount: totalCount } = getState();
                const nonHydrated = Object.keys(participantsToHydrateRef.current).find((key)=>{
                    return participantsToHydrateRef.current[key].sessions[sessionId];
                });
                if (nonHydrated) {
                    delete participantsToHydrateRef.current[nonHydrated];
                    setState({
                        totalCount: totalCount - 1
                    });
                } else {
                    const currentParticipants = new Map(participants);
                    const participant = (0, $9VtwR.getCurrentUserFromMap)(participants, sessionId);
                    if (participant) {
                        if (Object.keys(participant.sessions).length === 1) {
                            currentParticipants.delete(participant.id);
                            setState({
                                participants: currentParticipants,
                                totalCount: totalCount - 1
                            });
                        } else {
                            delete participant.sessions[sessionId];
                            currentParticipants.set(participant.id, participant);
                            setState({
                                participants: currentParticipants
                            });
                        }
                    }
                }
            },
        remove: (sessionId)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                const currentParticipants = new Map(participants);
                const participant = (0, $9VtwR.getCurrentUserFromMap)(participants, sessionId);
                if (participant) {
                    if (Object.keys(participant.sessions).length === 1) {
                        currentParticipants.delete(participant.id);
                        setState({
                            participants: currentParticipants
                        });
                    } else {
                        delete participant.sessions[sessionId];
                        currentParticipants.set(participant.id, participant);
                        setState({
                            participants: currentParticipants
                        });
                    }
                } else // eslint-disable-next-line no-console
                console.error('Could not remove participant with sessionId of ', sessionId);
            },
        addTelepointerData: (data)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const participant = (0, $9VtwR.getCurrentUserFromMap)(state.participants, data.sessionId);
                if (// Don't track the telepointer data for the current user
                Boolean(participant?.isCurrentUser) || !(0, $9wGTI.fg)('confluence_team_presence_scroll_to_pointer')) return;
                const telepointers = new Map(state.telepointers);
                telepointers.set(data.sessionId, {
                    ...data,
                    timestamp: Date.now()
                });
                setState({
                    telepointers: telepointers
                });
            }
    },
    name: 'PresenceStore'
});
const $2960af57d9597263$export$7033f12ef2e1cbf5 = (0, $iFWZA.createHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$afdb9ee4b69111fa = (0, $iFWZA.createActionsHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$23e4fe06e7659b53 = (0, $iFWZA.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: (state)=>state.participants
});
const $2960af57d9597263$export$4af6cc58a9a6c026 = (0, $iFWZA.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: (state)=>state.totalCount
});
const $2960af57d9597263$export$d8ba5bfd88808651 = (state, props)=>{
    const { participants: participants } = state;
    const participantValues = [
        ...participants.values()
    ];
    const currentUser = (0, $9VtwR.getCurrentUserFromMap)(participants, props.sessionId);
    return participantValues.map((participant)=>{
        return {
            ...participant,
            name: participant.userId === 'unidentified' ? props.anonymousName : participant.name,
            activity: participant.isCurrentUser && currentUser ? (0, $9VtwR.getActivityToDisplay)(participant.sessions, props.sessionId, props.activity) : (0, $9VtwR.getActivityToDisplay)(participant.sessions)
        };
    });
};
const $2960af57d9597263$export$5a5a291828ecb5e4 = (0, $iFWZA.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$d8ba5bfd88808651
});
const $2960af57d9597263$export$172cef4c4690b3ab = (state, sessions)=>Object.keys(sessions).map((sId)=>state.telepointers.get(sId)).filter((tData)=>!!tData).sort((a, b)=>b?.timestamp - a?.timestamp)?.[0];
const $2960af57d9597263$export$f1a08937c1f9340b = (0, $iFWZA.createHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$172cef4c4690b3ab
});
const $2960af57d9597263$export$f642eede20cf74c0 = (0, $2S0Fz.createContainer)($2960af57d9597263$var$PresenceStore, {
    onInit: ()=>({ setState: setState }, { participant: participant })=>{
            const defaultParticipants = new Map();
            if (participant) defaultParticipants.set(participant.id, {
                ...participant
            });
            setState({
                participants: defaultParticipants,
                totalCount: defaultParticipants.size
            });
        }
});

});
parcelRegister("kCM9P", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $e11cc79fee26f81c$export$8995abb8169b2cb8);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $e11cc79fee26f81c$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});

parcelRegister("9VtwR", function(module, exports) {

$parcel$export(module.exports, "getParticipantColors", () => $6bda54ffb0f4283a$export$2fbd87a2176aa7cf);
$parcel$export(module.exports, "getCurrentUserColors", () => $6bda54ffb0f4283a$export$fecb54e21647ae4f);
$parcel$export(module.exports, "getCurrentUserFromMap", () => $6bda54ffb0f4283a$export$a8078789f7ade13a);
$parcel$export(module.exports, "getActivityToDisplay", () => $6bda54ffb0f4283a$export$8c4801f1df434a3);
$parcel$export(module.exports, "getPresenceServiceUrl", () => $6bda54ffb0f4283a$export$cd367e77e21c7f3d);
$parcel$export(module.exports, "getPresenceClientId", () => $6bda54ffb0f4283a$export$73e42e5abf6898ab);
$parcel$export(module.exports, "MAX_GROUP_SIZE", () => $6bda54ffb0f4283a$export$dd4b75f1a6268a6b);
$parcel$export(module.exports, "CURRENT_USER_DUMMY_SESSION_ID", () => $6bda54ffb0f4283a$export$a9b806721f7a3927);

var $9HkI0 = parcelRequire("9HkI0");

var $jyw2s = parcelRequire("jyw2s");
var $aFUXX = parcelRequire("aFUXX");
const $6bda54ffb0f4283a$export$2fbd87a2176aa7cf = (id)=>{
    if (!id) return (0, $aFUXX.participantColors)[0];
    return (0, $jyw2s.getParticipantColor)(id).color;
};
const $6bda54ffb0f4283a$export$fecb54e21647ae4f = ()=>{
    return {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    };
};
const $6bda54ffb0f4283a$export$a8078789f7ade13a = (participants, sessionId)=>{
    if (sessionId) return [
        ...participants.values()
    ].find((p)=>p.sessions[sessionId]);
};
const $6bda54ffb0f4283a$export$8c4801f1df434a3 = (sessionData, currentUserSessionId, defaultActivity)=>{
    if (currentUserSessionId) return sessionData[currentUserSessionId]?.activity ?? defaultActivity ?? 'viewer';
    else {
        const hasEditor = Object.keys(sessionData).find((sessionId)=>sessionData[sessionId]?.activity === 'editor');
        return hasEditor ? 'editor' : 'viewer';
    }
};
const $6bda54ffb0f4283a$export$cd367e77e21c7f3d = ()=>{
    const route = 'collab-presence-confluence';
    if (window.location.hostname === 'localhost') {
        const host = window.__backendOriginHost;
        return `https://${host}/${route}`;
    }
    return `${window.location.origin}/${route}`;
};
const $6bda54ffb0f4283a$export$73e42e5abf6898ab = ()=>`presence-${(0, $9HkI0.v4)()}`;
const $6bda54ffb0f4283a$export$dd4b75f1a6268a6b = 4;
const $6bda54ffb0f4283a$export$a9b806721f7a3927 = 'dummy-session-id';

});
parcelRegister("jyw2s", function(module, exports) {

$parcel$export(module.exports, "getParticipantColor", () => $514d44140915e951$export$60ba61eca4eb64f2);

var $aFUXX = parcelRequire("aFUXX");
function $514d44140915e951$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $514d44140915e951$export$60ba61eca4eb64f2(str) {
    const index = $514d44140915e951$export$c14f61804029af13(str) % (0, $aFUXX.participantColors).length;
    return {
        index: index,
        color: (0, $aFUXX.participantColors)[index]
    };
}

});



parcelRegister("4jksU", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $bcb76fd0854e9b81$export$99c2b779aa4e8b8b);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gfIPU = parcelRequire("gfIPU");
var $irVI7 = parcelRequire("irVI7");

var $9wGTI = parcelRequire("9wGTI");

var $lkApp = parcelRequire("lkApp");

var $3yZAT = parcelRequire("3yZAT");

var $aC5ZO = parcelRequire("aC5ZO");

var $fgzua = parcelRequire("fgzua");

var $bLjbS = parcelRequire("bLjbS");
const $bcb76fd0854e9b81$var$i18n = (0, $2nPZH.defineMessages)({
    anonymousUser: {
        id: "team-presence.avatar-group.anonymous-user",
        defaultMessage: "Anonymous Person"
    }
});
const $bcb76fd0854e9b81$var$PagePresence = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, activity: activity, analyticSource: analyticSource })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { sessionId: sessionId, fetchMore: fetchMore, networkError: networkError, totalParticipants: totalParticipants } = (0, $bLjbS.usePresence)(contentId, contentType, contentMode, activity);
    const participants = (0, $lkApp.useTransformedParticipants)({
        activity: activity,
        sessionId: sessionId,
        anonymousName: formatMessage($bcb76fd0854e9b81$var$i18n.anonymousUser)
    });
    if (networkError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
        error: networkError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fgzua.PresenceChangeboarding), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        totalParticipants: totalParticipants
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aC5ZO.PresenceAvatarGroup), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        analyticSource: analyticSource,
        onLoadMoreClick: fetchMore,
        participants: participants,
        totalParticipants: totalParticipants
    }));
};
const $bcb76fd0854e9b81$var$OldPresence = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, activity: activity, analyticSource: analyticSource })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { sessionId: sessionId, fetchMore: fetchMore, networkError: networkError } = (0, $3yZAT.usePresenceProvider)(contentId, contentType, contentMode, activity);
    const participants = (0, $lkApp.useTransformedParticipants)({
        activity: activity,
        sessionId: sessionId,
        anonymousName: formatMessage($bcb76fd0854e9b81$var$i18n.anonymousUser)
    });
    const totalCount = (0, $lkApp.useTotalCount)();
    if (networkError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
        error: networkError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fgzua.PresenceChangeboarding), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        totalParticipants: totalCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aC5ZO.PresenceAvatarGroup), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        analyticSource: analyticSource,
        onLoadMoreClick: fetchMore,
        participants: participants,
        totalParticipants: totalCount
    }));
};
const $bcb76fd0854e9b81$export$99c2b779aa4e8b8b = (props)=>{
    return (0, $9wGTI.fg)('confluence_team_presence_batch_refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bcb76fd0854e9b81$var$PagePresence, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bcb76fd0854e9b81$var$OldPresence, props);
};

});
parcelRegister("3yZAT", function(module, exports) {

$parcel$export(module.exports, "usePresenceProvider", () => $dc88c6f160c12bc8$export$9f39139ebe798148);

var $gwFzn = parcelRequire("gwFzn");

var $hvdlr = parcelRequire("hvdlr");

var $jXpbL = parcelRequire("jXpbL");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $7Sm4c = parcelRequire("7Sm4c");

var $9wGTI = parcelRequire("9wGTI");

var $lkApp = parcelRequire("lkApp");

var $9VtwR = parcelRequire("9VtwR");

var $943tL = parcelRequire("943tL");

var $5gaYz = parcelRequire("5gaYz");
// 0.5 sec
const $dc88c6f160c12bc8$var$INTERVAL_TIME = 500;
const $dc88c6f160c12bc8$var$MAX_FETCH_SIZE = 25;
const $dc88c6f160c12bc8$export$9f39139ebe798148 = (contentId, contentType, contentMode, activity)=>{
    const shouldCreatePresenceConnection = contentMode === 'view';
    const [{ collabEditInitialized: collabEditInitialized, collabEditProvider: collabEditProvider }] = (0, $jXpbL.useNativeCollabState)();
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(true);
    const participantsToHydrateRef = (0, $gwFzn.useRef)({});
    const sessions = (0, $gwFzn.useRef)(new Set());
    const providerRef = (0, $gwFzn.useRef)(collabEditProvider);
    const [networkError, setNetworkError] = (0, $gwFzn.useState)(undefined);
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $gwFzn.useRef)(presenceId);
    const participants = (0, $lkApp.useParticipants)();
    const { cloudId: cloudId, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const isGuestOrAnonymous = isGuest || !isLoggedIn;
    const { addParticipant: addParticipant, addHydratedParticipant: addHydratedParticipant, addParticipantFromCollabSocket: addParticipantFromCollabSocket, removeParticipant: removeParticipant, addTelepointerData: addTelepointerData } = (0, $lkApp.usePresenceStoreActions)();
    (0, $5gaYz.usePresenceLimiter)({
        contentId: contentId,
        contentType: contentType,
        contentMode: contentMode,
        participants: participants,
        provider: providerRef.current
    });
    const onHandleFetchUsersComplete = (users)=>{
        users.forEach((user)=>{
            const { accountId: accountId } = user;
            const participant = participantsToHydrateRef.current[accountId];
            if (participant) addHydratedParticipant({
                ...user,
                sessions: participant.sessions,
                presenceId: participant.presenceId
            }, participantsToHydrateRef);
        });
    };
    const handleFetchUsersError = (error)=>{
        // want to prevent an infinite spam of api calls being made
        setNetworkError(error);
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    const { getUsers: getUserInformation } = (0, $943tL.usePresenceProviderQuery)({
        isGuestOrAnonymous: isGuestOrAnonymous,
        onComplete: onHandleFetchUsersComplete,
        onError: handleFetchUsersError
    });
    const handleOnViewPresenceUpdate = (0, $gwFzn.useCallback)(({ joined: joined, left: left })=>{
        joined?.map((joinedParticipant)=>{
            addParticipant({
                ...joinedParticipant
            }, participantsToHydrateRef);
        });
        left?.map((participant)=>{
            removeParticipant(participant.sessionId, participantsToHydrateRef);
        });
    }, // don't let this depend on anything with frequent state changes to avoid unnecessary subscribitions and unsubscriptions of the event handling
    [
        addParticipant,
        removeParticipant
    ]);
    const handleOnEditorPresenceUpdate = (0, $gwFzn.useCallback)(()=>{
        const people = (0, $9wGTI.fg)('confluence_native_collab_batch_fetch_user') ? collabEditProvider?.getParticipants().filter((p)=>p.isHydrated) : collabEditProvider?.getParticipants();
        people?.forEach((participant)=>{
            sessions.current.add(participant.sessionId);
            addParticipantFromCollabSocket(participant);
        });
        const participantSessions = people?.map((p)=>p.sessionId) ?? [];
        // getParticipants returns all active users, so need to determine which ones to remove
        sessions.current.forEach((sessionId)=>{
            if (!participantSessions.includes(sessionId)) {
                removeParticipant(sessionId, participantsToHydrateRef);
                sessions.current.delete(sessionId);
            }
        });
    }, // don't let this depend on anything with frequent state changes to avoid unnecessary subscribitions and unsubscriptions of the event handling
    [
        collabEditProvider,
        addParticipantFromCollabSocket,
        removeParticipant
    ]);
    const handleOnPresence = shouldCreatePresenceConnection ? handleOnViewPresenceUpdate : handleOnEditorPresenceUpdate;
    // TODO: Hmm, this is a noop. We should probably remove this.
    const handleOnViewPresenceChange = (0, $gwFzn.useCallback)(()=>{}, []);
    const handleOnEditorPresenceChange = (0, $gwFzn.useCallback)((_)=>{
        handleOnEditorPresenceUpdate();
    }, [
        handleOnEditorPresenceUpdate
    ]);
    const handleOnPresenceChange = shouldCreatePresenceConnection ? handleOnViewPresenceChange : handleOnEditorPresenceChange;
    const fetchMore = (count)=>{
        const accountIds = Object.keys(participantsToHydrateRef.current).slice(0, count);
        if (accountIds.length > 0) getUserInformation(accountIds);
    };
    const initializeProvider = (0, $gwFzn.useCallback)(async ()=>{
        if (!shouldCreatePresenceConnection) {
            setIsLoading(false);
            return;
        }
        const permissionTokenRefresh = (0, $jXpbL.fetchCollabPermissionToken)(contentId, undefined);
        const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
        // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
        // This means that anonymous users will still rely on presenceId and not get deduplicated.
        const collaboratorPresenceId = userId ?? presenceIdRef.current;
        try {
            const provider = (0, $hvdlr.createSocketIOCollabProvider)({
                url: (0, $9VtwR.getPresenceServiceUrl)(),
                documentAri: documentAri,
                permissionTokenRefresh: permissionTokenRefresh,
                need404: true,
                isPresenceOnly: true,
                productInfo: {
                    product: 'confluence',
                    subProduct: 'team-presence'
                },
                presenceId: collaboratorPresenceId,
                presenceActivity: 'viewer'
            });
            provider.setupForPresenceOnly((0, $9VtwR.getPresenceClientId)());
            providerRef.current = provider;
        } finally{
            setIsLoading(false);
        }
    }, [
        shouldCreatePresenceConnection,
        cloudId,
        contentId,
        contentType,
        userId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // When setting up the provider, whether or not it's a presence provider or editor provider. We should clear our
        // participant state, since this is based on contentId, there are edge cases that would cause participants to be sticky
        // as we switch between view and edit.
        participantsToHydrateRef.current = {};
        initializeProvider();
        // When we don't have a provider and we are not creating a presence connection,
        // we should use the existing collabEditProvider, there was an edge case where this provider wasn't
        // available on the first render.
        if (!providerRef.current && collabEditProvider) providerRef.current = collabEditProvider;
        providerRef.current?.on('presence', handleOnPresence);
        providerRef.current?.on('presence:changed', handleOnPresenceChange);
        providerRef.current?.on('telepointer', addTelepointerData);
        return ()=>{
            setIsLoading(true);
            providerRef.current?.off('presence', handleOnPresence);
            providerRef.current?.off('presence:changed', handleOnPresenceChange);
            providerRef.current?.off('telepointer', addTelepointerData);
            // we do not want to destroy the live connection, since we didn't create it
            if (shouldCreatePresenceConnection) providerRef.current?.destroy();
        };
    }, [
        collabEditProvider,
        shouldCreatePresenceConnection,
        initializeProvider,
        handleOnPresence,
        handleOnPresenceChange,
        addTelepointerData
    ]);
    (0, $gwFzn.useEffect)(()=>{
        presenceIdRef.current = presenceId;
    }, [
        presenceId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldCreatePresenceConnection || !collabEditInitialized) return;
        providerRef.current?.sendMessage({
            type: 'participant:activity',
            activity: activity
        });
    }, [
        activity,
        collabEditInitialized,
        shouldCreatePresenceConnection
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!shouldCreatePresenceConnection) return;
        // While the current user's key has not been hydrated, or the group size is less than the max group size before we
        // render the overflow. We will continue to hydrate the next keys every interval.
        const interval = setInterval(()=>{
            const hasCurrentUserKeyBeenHydrated = (0, $9VtwR.getCurrentUserFromMap)(participants, providerRef.current?.getSessionId());
            const nextKeysToHydrate = Object.keys(participantsToHydrateRef.current).slice(0, (0, $9VtwR.MAX_GROUP_SIZE) + 1);
            const shouldHydrateNextKeys = nextKeysToHydrate.length > 0 && (!hasCurrentUserKeyBeenHydrated || participants.size <= (0, $9VtwR.MAX_GROUP_SIZE));
            if (shouldHydrateNextKeys) // Keys in this scenario are actually presenceIds, but they currently map to accountIds
            // unless the user is anonymous. We short circuit anonymous users out of hydration, so they
            // will not be in this list.
            getUserInformation(nextKeysToHydrate);
        }, $dc88c6f160c12bc8$var$INTERVAL_TIME);
        if (networkError && interval) clearInterval(interval);
        return ()=>clearInterval(interval);
    }, [
        networkError,
        shouldCreatePresenceConnection,
        participants,
        getUserInformation
    ]);
    return {
        participantsToHydrateRef: // only returning this for testing purposes until I figure out something better
        participantsToHydrateRef,
        isLoading: isLoading,
        presenceId: presenceId,
        // want to return DUMMY as a default to preserve activity lookup if provider isn't available yet
        sessionId: providerRef.current?.getSessionId() ?? (0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID),
        fetchMore: ()=>fetchMore($dc88c6f160c12bc8$var$MAX_FETCH_SIZE),
        networkError: networkError
    };
};

});
parcelRegister("943tL", function(module, exports) {

$parcel$export(module.exports, "usePresenceProviderQuery", () => $59680410ef52cf09$export$af8a6641e5486ff4);

var $gKr8t = parcelRequire("gKr8t");
var $hp2SH = parcelRequire("hp2SH");

var $8Lx5S = parcelRequire("8Lx5S");

var $kgYWN = parcelRequire("kgYWN");

var $fZzCp = parcelRequire("fZzCp");
const $59680410ef52cf09$export$af8a6641e5486ff4 = ({ isGuestOrAnonymous: isGuestOrAnonymous, onComplete: onComplete, onError: onError })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    // need to use the non hook variety. useLazyHook is a good candidate; however trying to execute the query multiple
    // times won't cause a re-render if there's a cache hit. So use this way instead
    const getConfluenceUsers = (accountIds)=>{
        return (0, $hp2SH.getApolloClient)().query({
            query: (0, $kgYWN.PresenceProviderUserQuery),
            variables: {
                accountIds: accountIds
            }
        }).then(({ data: data })=>{
            const result = [];
            data?.confluenceUsers?.nodes?.filter((user)=>user).forEach((user)=>{
                const accountId = user?.accountId;
                // even though we filter out null users, the ts check thinks users can be null
                if (accountId) result.push({
                    accountId: accountId,
                    name: user?.displayName ?? '',
                    permissionType: user?.permissionType ?? undefined,
                    avatarPath: user?.profilePicture?.path ?? ''
                });
            });
            onComplete(result);
        }).catch(onError);
    };
    const getUsersFromAGG = (accountIds)=>{
        return (0, $gKr8t.getAGGClient)().query({
            query: (0, $fZzCp.PresenceProviderAGGUserQuery),
            variables: {
                accountIds: accountIds
            }
        }).then(({ data: data })=>{
            const result = [];
            data?.users?.filter((user)=>user).forEach((user)=>{
                const accountId = user.accountId;
                if (accountId) result.push({
                    accountId: accountId,
                    name: user.name ?? '',
                    avatarPath: user.picture ?? ''
                });
            });
            onComplete(result);
        }).catch(onError);
    };
    const getUsers = (accountIds)=>{
        return isGuestOrAnonymous || !isLicensed ? getUsersFromAGG(accountIds) : getConfluenceUsers(accountIds);
    };
    return {
        getUsers: getUsers
    };
};

});
parcelRegister("kgYWN", function(module, exports) {

$parcel$export(module.exports, "PresenceProviderUserQuery", () => $d0ee6fc4a90bb122$export$72a259ce8dc2d17);

var $d2LG0 = parcelRequire("d2LG0");
const $d0ee6fc4a90bb122$export$72a259ce8dc2d17 = (0, $d2LG0.default)`query PresenceProviderUserQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{profilePicture{isDefault path(type:RELATIVE)}...on KnownUser{accountId}...on UnknownUser{accountId}displayName permissionType}}}`;

});

parcelRegister("fZzCp", function(module, exports) {

$parcel$export(module.exports, "PresenceProviderAGGUserQuery", () => $fbf655cad344d5c8$export$3dfe26798249e314);

var $d2LG0 = parcelRequire("d2LG0");
const $fbf655cad344d5c8$export$3dfe26798249e314 = (0, $d2LG0.default)`query PresenceUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`;

});


parcelRegister("5gaYz", function(module, exports) {

$parcel$export(module.exports, "usePresenceLimiter", () => $e412362ca5524ae7$export$ca2b752d32a4ba83);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");
//TODO dynamic configs https://product-fabric.atlassian.net/browse/MDS-1207
const $e412362ca5524ae7$var$SESSION_LIMIT = 50;
const $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT = 1000;
const $e412362ca5524ae7$export$ca2b752d32a4ba83 = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, participants: participants, provider: provider })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const getTotalSessions = (0, $gwFzn.useCallback)(()=>{
        return provider?.getParticipants().length ?? 0;
    }, [
        provider
    ]);
    const checkSessionLimit = (0, $gwFzn.useCallback)((currentUser, totalSessions)=>{
        const currentUserHasReachedSessionLimit = currentUser && Object.keys(currentUser.sessions).length > $e412362ca5524ae7$var$SESSION_LIMIT;
        if (currentUserHasReachedSessionLimit || totalSessions > $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT) {
            provider?.destroy();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'presenceAvatarGroup',
                    action: 'destroyConnection',
                    actionSubject: 'presenceAvatarGroupConnection',
                    attributes: {
                        sessionLimitType: currentUserHasReachedSessionLimit ? 'currentUser' : 'totalSessions',
                        contentId: contentId,
                        contentType: contentType
                    }
                }
            }).fire();
        }
    }, [
        contentId,
        contentType,
        createAnalyticsEvent,
        provider
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // only for presence connections
        if (!(0, $9wGTI.fg)('confluence_team_presence_limiter') || contentMode !== 'view') return;
        const currentUser = participants.get(userId ?? 'unidentified');
        checkSessionLimit(currentUser, getTotalSessions());
    }, [
        checkSessionLimit,
        contentMode,
        participants,
        userId,
        getTotalSessions
    ]);
    return {};
};

});


parcelRegister("aC5ZO", function(module, exports) {

$parcel$export(module.exports, "PresenceAvatarGroup", () => $012cae68941ce2ca$export$fc163eae181faed4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2Pg7f = parcelRequire("2Pg7f");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $lGgRw = parcelRequire("lGgRw");

var $inPa6 = parcelRequire("inPa6");

var $ep3mz = parcelRequire("ep3mz");

var $lgKMU = parcelRequire("lgKMU");

var $9wGTI = parcelRequire("9wGTI");

var $1eaCJ = parcelRequire("1eaCJ");
var $irVI7 = parcelRequire("irVI7");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $hfPJk = parcelRequire("hfPJk");

var $9VtwR = parcelRequire("9VtwR");

var $g8Cct = parcelRequire("g8Cct");

var $5ZJn7 = parcelRequire("5ZJn7");

var $j66nf = parcelRequire("j66nf");

var $bF9T9 = parcelRequire("bF9T9");
const $012cae68941ce2ca$var$i18n = (0, $2nPZH.defineMessages)({
    overflowLabel: {
        id: "team-presence.avatar-group.overflow-label",
        defaultMessage: "Overflow menu"
    },
    blogpostLandmark: {
        id: "team-presence.avatar-group.blogpost-landmark",
        defaultMessage: "Active people on blog post"
    },
    pageLandmark: {
        id: "team-presence.avatar-group.page-landmark",
        defaultMessage: "Active people on page"
    }
});
const $012cae68941ce2ca$var$popupContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    position: 'relative',
    width: '360px'
});
const $012cae68941ce2ca$var$editObjectHeaderStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0'
});
const $012cae68941ce2ca$var$overflowMoreStyles = (0, $ecnYn.xcss)({
    padding: 'space.075',
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'border.radius.400',
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    ':hover': {
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $012cae68941ce2ca$var$moreActiveStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $012cae68941ce2ca$var$indicatorStyles = (0, $ecnYn.xcss)({
    minWidth: '28px',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    margin: 'space.025',
    borderRadius: 'border.radius.100',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.outline',
        outlineOffset: 'space.050'
    }
});
const $012cae68941ce2ca$var$indicatorOverflowStyles = (0, $ecnYn.xcss)({
    minWidth: '35px',
    maxWidth: '35px'
});
const $012cae68941ce2ca$export$fc163eae181faed4 = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, analyticSource: analyticSource, popupOpen: popupOpen, onLoadMoreClick: onLoadMoreClick, participants: participants, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [isPopupOpen, setIsPopupOpen] = (0, $gwFzn.useState)(popupOpen || false);
    const [isShareDialogOpen, setIsShareDialogOpen] = (0, $gwFzn.useState)(false);
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)();
    const isAllowedToShare = (0, $gwFzn.useCallback)(()=>{
        // only 1 user, not anonymous and not guest user
        return participants.length === 1 && isLoggedIn && !isGuest;
    }, [
        participants,
        isLoggedIn,
        isGuest
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isPopupOpen && participants.length > 1 && participants.length <= (0, $9VtwR.MAX_GROUP_SIZE)) setIsPopupOpen(false);
    }, [
        isPopupOpen,
        participants
    ]);
    const handleShareClick = (0, $gwFzn.useCallback)((analyticsTriggerSource)=>{
        setIsPopupOpen(false);
        let shareDialogType;
        if ((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) {
            shareDialogType = 'v2';
            setIsShareDialogOpen(true);
        } else {
            shareDialogType = 'old';
            (0, $j66nf.switchToShareDialog)((openShare)=>{
                if (openShare) openShare();
            });
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsTriggerSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceShare',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType,
                    shareDialog: shareDialogType
                }
            }
        }).fire();
    }, [
        contentId,
        contentMode,
        contentType,
        createAnalyticsEvent,
        isUSDExperimentEnabled
    ]);
    const toggleEmptyPresenceDialog = (0, $gwFzn.useCallback)(()=>{
        if (isAllowedToShare()) {
            setIsPopupOpen((isPopupOpenState)=>!isPopupOpenState);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: analyticSource,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'singlePresenceAvatarGroup',
                    product: 'confluence',
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        toggle: isPopupOpen ? 'close' : 'open'
                    }
                }
            }).fire();
        }
    }, [
        contentId,
        contentMode,
        contentType,
        analyticSource,
        createAnalyticsEvent,
        isPopupOpen,
        isAllowedToShare
    ]);
    const isSingleParticipant = Boolean(participants && totalParticipants === 1);
    const onMoreClick = (0, $gwFzn.useCallback)((e, number)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceAvatarGroupMoreButton',
                product: 'confluence',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    number: number
                }
            }
        }).fire();
        setIsPopupOpen((isPopupOpenState)=>!isPopupOpenState);
        // platform-design-system-popup-ref causes the popup to close when the user clicks on the more button,
        // revisit what other types of changes we can put in place to not have to call stopPropagation
        e.stopPropagation();
    }, [
        contentId,
        contentType,
        contentMode,
        analyticSource,
        createAnalyticsEvent
    ]);
    const triggerId = isSingleParticipant ? 'no-collaborators-dialog' : 'presence-menu';
    const PopupContent = isSingleParticipant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5ZJn7.NoCollaboratorsDialog), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        spaceKey: spaceKey || '',
        onShareClick: handleShareClick,
        testId: triggerId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g8Cct.PresenceMenu), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        onLoadMoreClick: onLoadMoreClick,
        totalParticipants: totalParticipants,
        participants: participants,
        testId: triggerId
    });
    const overflowParticipantCount = totalParticipants - (0, $9VtwR.MAX_GROUP_SIZE) + 1;
    const landmarkRegionLabel = contentType === 'blogpost' ? formatMessage($012cae68941ce2ca$var$i18n.blogpostLandmark) : formatMessage($012cae68941ce2ca$var$i18n.pageLandmark);
    const isEditObjectHeader = (0, $9wGTI.fg)('confluence_frontend_object_header') && (contentMode === 'edit' || contentMode === 'live');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
    }), participants.length === 1 && isShareDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lgKMU.ShareAndRestrictDialogController), {
        contentId: contentId,
        contentType: contentType,
        allowRestrictions: true,
        pageModes: "view",
        refetchButtonData: ()=>{},
        onClose: ()=>{
            setIsShareDialogOpen(false);
        },
        isUnpublishedDraft: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $012cae68941ce2ca$var$popupContainerStyles
            }, PopupContent),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                ...triggerProps,
                paddingInline: "space.050",
                paddingBlock: "space.025",
                "aria-label": landmarkRegionLabel,
                role: "region",
                xcss: isEditObjectHeader && $012cae68941ce2ca$var$editObjectHeaderStyles,
                "data-vc": "presence-avatar-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pg7f.default), {
                appearance: "stack",
                size: "small",
                maxCount: (0, $9VtwR.MAX_GROUP_SIZE),
                data: participants,
                testId: "presence-avatar-group",
                label: landmarkRegionLabel,
                borderColor: "var(--ds-background-neutral, #091E420F)",
                onMoreClick: (e)=>onMoreClick(e, overflowParticipantCount),
                shouldPopupRenderToParent: false,
                isTooltipDisabled: true,
                overrides: {
                    Avatar: {
                        render: (_, props, index)=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bF9T9.PresenceAvatarButton), {
                                key: `PresenceAvatarButton-${index}`,
                                index: index,
                                participant: participants[index],
                                contentMode: contentMode,
                                contentType: contentType,
                                contentId: contentId,
                                isSingleParticipant: isSingleParticipant,
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                avatarProps: props,
                                analyticSource: analyticSource
                            });
                        }
                    },
                    MoreIndicator: {
                        render: (_, { buttonProps: buttonProps, isActive: isActive, borderColor: borderColor, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
                                type: "submit",
                                ...buttonProps,
                                ...rest,
                                padding: "space.025",
                                onClick: rest.onClick,
                                xcss: [
                                    $012cae68941ce2ca$var$indicatorStyles,
                                    // TODO: This is a bug, anything above 1000 will break...
                                    overflowParticipantCount > 100 && $012cae68941ce2ca$var$indicatorOverflowStyles
                                ],
                                testId: rest.testId,
                                "data-vc": "presence-overflow",
                                "aria-label": formatMessage($012cae68941ce2ca$var$i18n.overflowLabel)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                                xcss: [
                                    $012cae68941ce2ca$var$overflowMoreStyles,
                                    isPopupOpen && $012cae68941ce2ca$var$moreActiveStyles
                                ]
                            }, overflowParticipantCount))
                    }
                }
            }))
    }));
};

});
parcelRegister("lgKMU", function(module, exports) {

$parcel$export(module.exports, "ShareAndRestrictDialogController", () => $d6607a34d68309a3$export$9542b2119eeb5eb4);

var $jmjWc = parcelRequire("jmjWc");

const $d6607a34d68309a3$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2Q0Hi",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("ehtmb"))).Controller
});

});
parcelRegister("ehtmb", function(module, exports) {

let $a6596ce0d9080171$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a6596ce0d9080171$var$load("3kHns"),
    $a6596ce0d9080171$var$load("3JzPO"),
    $a6596ce0d9080171$var$load("h4Nf7"),
    $a6596ce0d9080171$var$load("4fCJZ"),
    $a6596ce0d9080171$var$load("dTsOE"),
    $a6596ce0d9080171$var$load("6zfzy"),
    $a6596ce0d9080171$var$load("6StWh"),
    $a6596ce0d9080171$var$load("8sFYu"),
    $a6596ce0d9080171$var$load("gkmZg"),
    $a6596ce0d9080171$var$load("a4Sf9"),
    $a6596ce0d9080171$var$load("kQvbt"),
    $a6596ce0d9080171$var$load("jQFGH"),
    $a6596ce0d9080171$var$load("fQ1rW"),
    $a6596ce0d9080171$var$load("4tUsp"),
    $a6596ce0d9080171$var$load("6qah4"),
    $a6596ce0d9080171$var$load("9FBaW"),
    $a6596ce0d9080171$var$load("c6MKV"),
    $a6596ce0d9080171$var$load("aZinD"),
    $a6596ce0d9080171$var$load("cyGuT"),
    $a6596ce0d9080171$var$load("6Yu8N"),
    $a6596ce0d9080171$var$load("fnUik"),
    $a6596ce0d9080171$var$load("TpLgp")
]).then(()=>parcelRequire('itC5w'));

});


parcelRegister("hfPJk", function(module, exports) {

$parcel$export(module.exports, "useUnifiedShareDialogEligible", () => $4c837cd68f9ce4c0$export$ec1a39480eeb12ae);

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $6mKj3 = parcelRequire("6mKj3");
const $4c837cd68f9ce4c0$export$ec1a39480eeb12ae = (skipExposure = false)=>{
    const { edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = [
        (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
        (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS
    ].includes(accessStatus);
    const isStandard = [
        (0, $euL71.ConfluenceEdition).STANDARD
    ].includes(edition);
    const isEligible = isLoggedIn && isLicensed && isStandard;
    return {
        isUSDExperimentEnabled: isEligible ? skipExposure ? (0, $6mKj3.expValEqualsNoExposure)('unified_share_dialog_usd_experiment', 'cohort', 'test') : (0, $6mKj3.expValEquals)('unified_share_dialog_usd_experiment', 'cohort', 'test') : false
    };
};

});

parcelRegister("g8Cct", function(module, exports) {

$parcel$export(module.exports, "PresenceMenu", () => $d97f196b60da1ace$export$54d27edd10ac5407);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $56M4r = parcelRequire("56M4r");
var $2SlZp = parcelRequire("2SlZp");
var $7rvPL = parcelRequire("7rvPL");

var $inPa6 = parcelRequire("inPa6");

var $992wm = parcelRequire("992wm");
const $d97f196b60da1ace$var$i18n = (0, $2nPZH.defineMessages)({
    activeNowTitle: {
        id: "team-presence.menu.active.title",
        defaultMessage: "{count, plural, =0 {Active now ({count})} one {Active now ({count})} other {Active now ({count})}}"
    },
    viewingNowTitle: {
        id: "team-presence.menu.viewing.title",
        defaultMessage: "{count, plural, =0 {Viewing now ({count})} one {Viewing now ({count})} other {Viewing now ({count})}}"
    },
    editingNowTitle: {
        id: "team-presence.menu.editing.title",
        defaultMessage: "{count, plural, =0 {Editing now ({count})} one {Editing now ({count})} other {Editing now ({count})}}"
    },
    commenting: {
        id: "team-presence.menu.commenting",
        defaultMessage: "Commenting"
    },
    you: {
        id: "team-presence.menu.you",
        defaultMessage: "You"
    },
    loadMore: {
        id: "team-presence.menu.load-more.non-final",
        defaultMessage: "Load More"
    }
});
const $d97f196b60da1ace$export$54d27edd10ac5407 = ({ participants: participants, contentMode: contentMode, testId: testId, contentId: contentId, contentType: contentType, onLoadMoreClick: onLoadMoreClick, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'presenceMenu',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType,
        contentMode
    ]);
    const getHeaderTitle = (0, $gwFzn.useCallback)((count)=>{
        if (contentMode === 'edit' && (contentType === 'page' || contentType === 'blogpost')) return formatMessage($d97f196b60da1ace$var$i18n.editingNowTitle, {
            count: count
        });
        else if (contentMode === 'view' && (contentType === 'page' || contentType === 'blogpost')) return formatMessage($d97f196b60da1ace$var$i18n.viewingNowTitle, {
            count: count
        });
        else // contentType === 'live'
        return formatMessage($d97f196b60da1ace$var$i18n.activeNowTitle, {
            count: count
        });
    }, [
        contentMode,
        contentType,
        formatMessage
    ]);
    const handleOnLoadMoreClicked = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'presenceMenuLoadMore',
                source: 'presenceMenu',
                attributes: {
                    participantsHydrated: participants.length,
                    totalParticipants: totalParticipants
                }
            }
        }).fire();
        onLoadMoreClick();
    }, [
        createAnalyticsEvent,
        onLoadMoreClick,
        participants,
        totalParticipants
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2SlZp.default), {
        maxHeight: 480,
        minWidth: 360,
        maxWidth: 360,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rvPL.default), {
        isScrollable: true,
        title: getHeaderTitle(totalParticipants),
        testId: "presence-menu-group"
    }, participants.map((participant, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $992wm.PresenceMenuItem), {
            key: `menu-item-${participant.id.slice(6)}`,
            participant: participant,
            contentMode: contentMode,
            contentId: contentId,
            contentType: contentType,
            isCurrentUser: index === 0
        })), totalParticipants !== participants.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        onClick: handleOnLoadMoreClicked
    }, formatMessage($d97f196b60da1ace$var$i18n.loadMore))));
};

});
parcelRegister("992wm", function(module, exports) {

$parcel$export(module.exports, "PresenceMenuItem", () => $3483060680d51265$export$e2b8ad06fb5a352f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $aIk0I = parcelRequire("aIk0I");

var $56M4r = parcelRequire("56M4r");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $9fywD = parcelRequire("9fywD");

var $9VtwR = parcelRequire("9VtwR");

var $dv6q2 = parcelRequire("dv6q2");

var $uBose = parcelRequire("uBose");
const $3483060680d51265$var$i18n = (0, $2nPZH.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    you: {
        id: "team-presence.menu.current-user.marker",
        defaultMessage: "You"
    },
    clickToFind: {
        id: "team-presence.menu-item.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu-item.click-to-find-not-available.non-final",
        defaultMessage: "Idle"
    },
    clickToFollow: {
        id: "team-presence.menu-item.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $3483060680d51265$var$DESCRIPTION_SEPARATOR = ' - ';
const $3483060680d51265$var$hiddenStyle = (0, $ecnYn.xcss)({
    visibility: 'hidden'
});
const $3483060680d51265$var$visibleStyle = (0, $ecnYn.xcss)({
    visibility: 'visible'
});
const $3483060680d51265$export$e2b8ad06fb5a352f = ({ participant: participant, contentMode: contentMode, contentId: contentId, contentType: contentType, isCurrentUser: isCurrentUser })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $dv6q2.useScrollToTelepointer)({
        contentType: contentType,
        contentMode: contentMode,
        // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
        participant: participant
    });
    const isAnonymous = participant.userId === 'unidentified';
    const hasOnClickEvent = isEligibleToScroll || Boolean(participant.onClick);
    const handleClick = (0, $gwFzn.useCallback)(()=>{
        let isScrollSuccessful = false;
        if (isEligibleToScroll) isScrollSuccessful = scrollToTelepointer();
        if (participant.onClick) participant.onClick();
        if (hasOnClickEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: 'confluence',
                source: 'presenceMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceMenuItem',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                    isEligibleToScroll: isEligibleToScroll,
                    isScrollSuccessful: isScrollSuccessful
                }
            }
        }).fire();
    }, [
        participant,
        contentId,
        contentType,
        contentMode,
        isScrollToFeatureEnabled,
        isEligibleToScroll,
        hasOnClickEvent,
        scrollToTelepointer,
        createAnalyticsEvent
    ]);
    // A JS-based hover interaction is usually not preferred over pure CSS,
    // but since nested CSS selectors are discouraged (see the "no-nested-selectors" linting rule),
    // and we don’t have control over "ButtonItem", this seems to be the fastest valid solution for now.
    const [isHovered, setHover] = (0, $gwFzn.useState)(false);
    const handleFocus = ()=>{
        if (isScrollToFeatureEnabled || contentType === 'whiteboard') setHover(true);
    };
    const handleBlur = ()=>{
        if (isScrollToFeatureEnabled || contentType === 'whiteboard') setHover(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        onMouseEnter: handleFocus,
        onFocus: handleFocus,
        onMouseLeave: handleBlur,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        onClick: handleClick,
        testId: "team-presence-menu-item",
        "data-vc": "team-presence-menu-item",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $uBose.PresenceAvatar), {
            name: participant.name,
            src: participant.src,
            testId: "team-presence-menu-item-avatar",
            badgeTextColor: isCurrentUser ? (0, $9VtwR.getCurrentUserColors)().textColor : (0, $9VtwR.getParticipantColors)(participant.id).textColor,
            borderColor: isCurrentUser ? (0, $9VtwR.getCurrentUserColors)().backgroundColor : (0, $9VtwR.getParticipantColors)(participant.id).backgroundColor,
            activity: participant.activity ?? 'viewer',
            contentMode: contentMode,
            contentId: contentId,
            contentType: contentType,
            isEligibleToScroll: isEligibleToScroll
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, contentType !== 'whiteboard' && (participant.activity === 'editor' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.editing) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.viewing)), contentType === 'whiteboard' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: isHovered ? $3483060680d51265$var$visibleStyle : $3483060680d51265$var$hiddenStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.clickToFollow)), isScrollToFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: isHovered ? $3483060680d51265$var$visibleStyle : $3483060680d51265$var$hiddenStyle
        }, $3483060680d51265$var$DESCRIPTION_SEPARATOR, isEligibleToScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.clickToFindNotAvailable)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "baseline",
        gap: "space.050"
    }, participant.name, participant.isGuest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9fywD.ExternalUserLozenge), null), isCurrentUser && isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aIk0I.default), {
        appearance: "inprogress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.you)))));
};

});
parcelRegister("dv6q2", function(module, exports) {

$parcel$export(module.exports, "useScrollToTelepointer", () => $99b335d011a83318$export$3e8e4ca69eec4635);

var $gwFzn = parcelRequire("gwFzn");

var $h3X17 = parcelRequire("h3X17");

var $kDhla = parcelRequire("kDhla");

var $9wGTI = parcelRequire("9wGTI");

var $lkApp = parcelRequire("lkApp");
const $99b335d011a83318$export$3e8e4ca69eec4635 = ({ contentType: contentType, contentMode: contentMode, participant: participant })=>{
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }] = (0, $kDhla.useFullPageEditorApi)();
    // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
    const [activeTelepointer] = (0, $lkApp.useActiveTelepointerBySessions)(participant?.sessions ?? {});
    const activeTelepointerPos = activeTelepointer?.selection.head;
    const activeSessionId = activeTelepointer?.sessionId;
    const isScrollToFeatureEnabled = // This feature is only available for page and blogposts
    (contentType === 'page' || contentType === 'blogpost') && // ...and not in view mode
    contentMode !== 'view' && // Current user won't have the onClick handler for scroll
    !participant?.isCurrentUser && // Only available if the FG allows us
    (0, $9wGTI.fg)('confluence_team_presence_scroll_to_pointer');
    const isEligibleToScroll = isScrollToFeatureEnabled && // This is to filter out cases like where we have a user but no telepointer data; e.g. no focus on the doc
    activeTelepointerPos !== undefined && activeSessionId !== undefined;
    const observerRef = (0, $gwFzn.useRef)(null);
    const timeoutRef = (0, $gwFzn.useRef)(null);
    const killObserver = ()=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    // Clean up the observer when the component unmounts
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            killObserver();
        };
    }, []);
    // Returns a boolean which indicates whether the scroll was successful or not
    const scrollToTelepointer = (0, $gwFzn.useCallback)(()=>{
        killObserver();
        const scrollToPos = fullPageEditorPresetAPI?.core.actions.scrollToPos;
        const nudgeTelepointer = fullPageEditorPresetAPI?.collabEdit?.commands.nudgeTelepointer;
        if (!isEligibleToScroll || !scrollToPos) return false;
        const isScrollSuccessful = scrollToPos(Number(activeTelepointerPos), {
            behavior: 'smooth',
            block: 'center'
        });
        const telepointerEl = document.querySelector(`[${(0, $h3X17.TELEPOINTER_DATA_SESSION_ID_ATTR)}="${activeSessionId}"]`);
        if (isScrollSuccessful && nudgeTelepointer && telepointerEl) {
            // We don't run this callback in SSR, so no need to escape it with an isSSR check
            // eslint-disable-next-line no-restricted-syntax
            observerRef.current = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) {
                    fullPageEditorPresetAPI?.core.actions.execute(nudgeTelepointer(activeSessionId));
                    killObserver();
                }
            });
            observerRef.current.observe(telepointerEl);
            // Edge case: Set a timeout to disconnect the observer if intersection doesn't happen
            // 5000ms is an arbitrary time and can be reduced.
            timeoutRef.current = setTimeout(()=>{
                killObserver();
            }, 5000);
        }
        return isScrollSuccessful;
    }, [
        isEligibleToScroll,
        fullPageEditorPresetAPI,
        activeTelepointerPos,
        activeSessionId
    ]);
    return {
        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
        isEligibleToScroll: isEligibleToScroll,
        scrollToTelepointer: scrollToTelepointer
    };
};

});
parcelRegister("kDhla", function(module, exports) {

$parcel$export(module.exports, "useFullPageEditorApi", () => $9a24de4c41696be8$export$dc2b462ca736d2cc);
$parcel$export(module.exports, "useFullPageEditorApiActions", () => $9a24de4c41696be8$export$6e619048e155ac67);
$parcel$export(module.exports, "useFullPageEditorApiState", () => $9a24de4c41696be8$export$4875e84e17c56c5c);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $4ZoIm.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $iFWZA.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $iFWZA.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $iFWZA.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);

});


parcelRegister("uBose", function(module, exports) {

$parcel$export(module.exports, "PresenceAvatar", () => $09acd215ab95c7d5$export$9b9667d767e90372);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $esRft = parcelRequire("esRft");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $8UfDJ = parcelRequire("8UfDJ");
const $09acd215ab95c7d5$var$i18n = (0, $2nPZH.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    clickToFind: {
        id: "team-presence.menu.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu.click-to-find-not-available.non-final",
        defaultMessage: "Idle"
    },
    clickToFollow: {
        id: "team-presence.menu.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $09acd215ab95c7d5$var$containerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $09acd215ab95c7d5$var$avatarBadgeStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    height: '12px',
    width: '12px',
    borderRadius: '3px',
    color: 'color.text.inverse',
    // TODO: This will need to be swapped for the foregroundColor, based on sessionId
    boxShadow: 'elevation.shadow.overflow',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '10px',
    zIndex: 'card'
});
const $09acd215ab95c7d5$var$EditorAvatarBadge = ({ borderColor: backgroundColor, badgeTextColor: badgeTextColor, contentMode: contentMode, name: name })=>{
    const shouldRenderEditIcon = contentMode === 'view';
    const firstInitial = name?.substring(0, 1);
    /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/design-system/consistent-css-prop-usage,@atlaskit/ui-styling-standard/no-unsafe-values */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        testId: "editor-avatar-badge",
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $09acd215ab95c7d5$var$avatarBadgeStyles,
            (0, $ecnYn.xcss)({
                backgroundColor: backgroundColor,
                color: badgeTextColor
            })
        ]
    }, shouldRenderEditIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8UfDJ.EditIcon), {
        testId: "editor-avatar-badge-icon",
        "aria-label": "editor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "editor-avatar-badge-initial",
        as: "span"
    }, firstInitial));
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/design-system/consistent-css-prop-usage,@atlaskit/ui-styling-standard/no-unsafe-values */ };
const $09acd215ab95c7d5$export$9b9667d767e90372 = ({ activity: activity, badgeTextColor: badgeTextColor, contentMode: contentMode, contentId: contentId, contentType: contentType, name: name, isEligibleToScroll: isEligibleToScroll, isScrollToFeatureEnabled: isScrollToFeatureEnabled, ...avatarProps })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const activityText = activity === 'editor' ? formatMessage($09acd215ab95c7d5$var$i18n.editing) : formatMessage($09acd215ab95c7d5$var$i18n.viewing);
    const label = contentType === 'whiteboard' ? name : `${name} (${activityText})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, label, contentType === 'whiteboard' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $09acd215ab95c7d5$var$i18n.clickToFollow)), Boolean(isScrollToFeatureEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
            justifyContent: "center"
        }, Boolean(isEligibleToScroll) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $09acd215ab95c7d5$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $09acd215ab95c7d5$var$i18n.clickToFindNotAvailable)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.0",
        xcss: $09acd215ab95c7d5$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        ...avatarProps,
        appearance: "circle",
        size: "small",
        name: name,
        label: label
    }), activity === 'editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($09acd215ab95c7d5$var$EditorAvatarBadge, {
        borderColor: avatarProps.borderColor,
        badgeTextColor: badgeTextColor,
        contentMode: contentMode,
        name: name
    })));
};

});
parcelRegister("8UfDJ", function(module, exports) {

$parcel$export(module.exports, "EditIcon", () => $b923c56f908bf5f6$export$2ad141e9e3d81b82);

var $gwFzn = parcelRequire("gwFzn");

var $1s5hv = parcelRequire("1s5hv");
const $b923c56f908bf5f6$export$2ad141e9e3d81b82 = ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        testId: testId,
        alignItems: "center",
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"
    })));

});




parcelRegister("5ZJn7", function(module, exports) {

$parcel$export(module.exports, "NoCollaboratorsDialog", () => $1fc817270f48d66d$export$3566bbc3d99e9268);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $9wGTI = parcelRequire("9wGTI");

var $efvKr = parcelRequire("efvKr");

var $hfPJk = parcelRequire("hfPJk");

var $2RHOI = parcelRequire("2RHOI");
const $1fc817270f48d66d$var$i18n = (0, $2nPZH.defineMessages)({
    blogpostViewing: {
        id: "team-presence.menu.empty-state.blogpost.viewing",
        defaultMessage: "You\u2019re the only one viewing this blog post."
    },
    blogpostEditing: {
        id: "team-presence.menu.empty-state.blogpost.editing",
        defaultMessage: "You\u2019re the only one editing this blog post."
    },
    pageViewing: {
        id: "team-presence.menu.empty-state.page.viewing",
        defaultMessage: "You\u2019re the only one viewing this page."
    },
    pageEditing: {
        id: "team-presence.menu.empty-state.page.editing",
        defaultMessage: "You\u2019re the only one editing this page."
    },
    shareItWithOthersText: {
        id: "team-presence.menu.empty-state.share-it-with-others",
        defaultMessage: "Share it with others who might be interested."
    },
    publishToShareItWithOthersText: {
        id: "team-presence.menu.empty-state.publish-to-share-it-with-others",
        defaultMessage: "Publish it to share with others who might be interested."
    },
    copyLinkButtonText: {
        id: "team-presence.menu.empty-state.copy-button",
        defaultMessage: "Copy link"
    },
    sharePageButtonText: {
        id: "team-presence.menu.empty-state.page.share-button",
        defaultMessage: "Share page"
    },
    shareBlogPostButtonText: {
        id: "team-presence.menu.empty-state.blogpost.share-button",
        defaultMessage: "Share blog post"
    },
    sharePageButtonClickedText: {
        id: "team-presence.menu.empty-state.page.share-button.clicked",
        defaultMessage: "Page shared"
    },
    shareBlogPostButtonClickedText: {
        id: "team-presence.menu.empty-state.blogpost.share-button.clicked",
        defaultMessage: "Blogpost shared"
    },
    whiteboardModalDescription: {
        id: "team-presence.menu.empty-state.whiteboard",
        defaultMessage: "You\u2019re the only one on this whiteboard."
    },
    shareWhiteboardButtonText: {
        id: "team-presence.menu.empty-state.whiteboard.share-button",
        defaultMessage: "Share whiteboard"
    },
    shareWhiteboardButtonClickedText: {
        id: "team-presence.menu.empty-state.whiteboard.share-button.clicked",
        defaultMessage: "Whiteboard shared"
    },
    databaseModalDescription: {
        id: "team-presence.menu.empty-state.database",
        defaultMessage: "You\u2019re the only one on this database."
    },
    shareDatabaseButtonText: {
        id: "team-presence.menu.empty-state.database.share-button",
        defaultMessage: "Share database"
    },
    shareDatabaseButtonClickedText: {
        id: "team-presence.menu.empty-state.database.share-button.clicked",
        defaultMessage: "Database shared"
    }
});
const $1fc817270f48d66d$var$contentTypeToTranslationMap = (formatMessage, contentMode, isShareButtonDisabled)=>{
    return {
        blogpost: {
            modalDescriptionLineOne: formatMessage(contentMode === 'edit' ? $1fc817270f48d66d$var$i18n.blogpostEditing : $1fc817270f48d66d$var$i18n.blogpostViewing),
            modalDescriptionLineTwo: formatMessage(isShareButtonDisabled ? $1fc817270f48d66d$var$i18n.publishToShareItWithOthersText : $1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareBlogPostButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareBlogPostButtonClickedText)
        },
        page: {
            modalDescriptionLineOne: formatMessage(contentMode === 'edit' ? $1fc817270f48d66d$var$i18n.pageEditing : $1fc817270f48d66d$var$i18n.pageViewing),
            modalDescriptionLineTwo: formatMessage(isShareButtonDisabled ? $1fc817270f48d66d$var$i18n.publishToShareItWithOthersText : $1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.sharePageButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.sharePageButtonClickedText)
        },
        whiteboard: {
            modalDescriptionLineOne: formatMessage($1fc817270f48d66d$var$i18n.whiteboardModalDescription),
            modalDescriptionLineTwo: formatMessage($1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareWhiteboardButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareWhiteboardButtonClickedText)
        },
        database: {
            modalDescriptionLineOne: formatMessage($1fc817270f48d66d$var$i18n.databaseModalDescription),
            modalDescriptionLineTwo: formatMessage($1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareDatabaseButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareDatabaseButtonClickedText)
        }
    };
};
const $1fc817270f48d66d$export$3566bbc3d99e9268 = ({ contentMode: contentMode, onShareClick: onShareClick, contentId: contentId, contentType: contentType, spaceKey: spaceKey, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    // Determine if the user is in edit mode. Live pages supports both edit and view modes, so
    // we need to do an additional check to see if we're in edit mode on a live pages.
    const isInEditMode = contentMode === 'edit' || contentMode === 'live' && isLiveEditMode;
    const pageMode = isInEditMode ? 'edit' : 'view';
    /*
  On edit classic page, there is no Share button (only "Update" button).
  Since there is no Share button on edit classic page with a share dialog, clicking the Share button on this modal doesn't do anything,
  so we are disabling the Share button on edit mode.
  */ const isShareButtonDisabled = !((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) && contentMode === 'edit';
    const translations = $1fc817270f48d66d$var$contentTypeToTranslationMap(formatMessage, pageMode, isShareButtonDisabled)[contentType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        paddingInline: "space.200",
        paddingBlockStart: "space.200"
    }, translations.modalDescriptionLineOne, "\xa0", translations.modalDescriptionLineTwo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2RHOI.NoCollaboratorsDialogShareOptions), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        copyLinkButtonLabel: formatMessage($1fc817270f48d66d$var$i18n.copyLinkButtonText),
        shareButtonLabel: translations.shareButtonText,
        isShareButtonDisabled: isShareButtonDisabled,
        onShareClick: onShareClick
    }));
};

});
parcelRegister("2RHOI", function(module, exports) {

$parcel$export(module.exports, "NoCollaboratorsDialogShareOptions", () => $b0043606230dc18b$export$e28fc561c2630abb);

var $gwFzn = parcelRequire("gwFzn");

var $hArLp = parcelRequire("hArLp");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");

var $hkzol = parcelRequire("hkzol");
const $b0043606230dc18b$export$e28fc561c2630abb = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, pageMode: pageMode, spaceKey: spaceKey, copyLinkButtonLabel: copyLinkButtonLabel, shareButtonLabel: shareButtonLabel, isShareButtonDisabled: isShareButtonDisabled, onShareClick: onShareClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onShare = (0, $gwFzn.useCallback)((_)=>{
        if (onShareClick) onShareClick('noCollaboratorsDialog');
    }, [
        onShareClick
    ]);
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'noCollaboratorsDialogShareOptions',
                attributes: {
                    contentMode: contentMode,
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentMode,
        contentType,
        pageMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        padding: "space.200",
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hkzol.CopyLinkButton), {
        buttonAppearance: "subtle",
        buttonText: copyLinkButtonLabel,
        contentId: contentId,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        source: "noCollaboratorsDialog",
        shouldFitContainer: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        testId: "open-share-dialog",
        appearance: "default",
        onClick: onShare,
        isDisabled: isShareButtonDisabled
    }, shareButtonLabel))));
};

});
parcelRegister("hkzol", function(module, exports) {

$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5e3895b62fe84f52$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CopyLinkButton", () => $5e3895b62fe84f52$export$534d10f1c5b9c7b3);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $1bY7o = parcelRequire("1bY7o");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $3gadb = parcelRequire("3gadb");

var $6F6hl = parcelRequire("6F6hl");

var $dEBDF = parcelRequire("dEBDF");

var $6abPE = parcelRequire("6abPE");

var $jooGc = parcelRequire("jooGc");
const $5e3895b62fe84f52$var$i18n = (0, $2nPZH.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', shouldFitContainer: shouldFitContainer = true, buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor })=>{
    const intl = (0, $dBxQj.default)();
    const cleanupCopiedTimer = (0, $gwFzn.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $gwFzn.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $gwFzn.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    (0, $gwFzn.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $gwFzn.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $dEBDF.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            await copyContentLink();
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $gwFzn.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            shouldFitContainer: shouldFitContainer
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return confirmationText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, getCopyButton()));
};

});
parcelRegister("6abPE", function(module, exports) {

$parcel$export(module.exports, "useCopyContentLink", () => $68bb0af1984f782c$export$a049904f049cf16d);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $inPa6 = parcelRequire("inPa6");

var $7zgzO = parcelRequire("7zgzO");

var $1NBp8 = parcelRequire("1NBp8");

var $kfIha = parcelRequire("kfIha");

var $hkzol = parcelRequire("hkzol");
const $68bb0af1984f782c$var$useCopyContentLinkCopyLinkQuery = (0, $d2LG0.default)`query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id links{editui webui tinyui base}}}`;
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $gwFzn.useState)();
    const { toUrl: toUrl } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $j1Ss3.useQuery)($68bb0af1984f782c$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        }
    });
    const makeContentLink = (0, $gwFzn.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            // omit databases and other unsupported content types
            default:
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $gwFzn.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};

});
parcelRegister("kfIha", function(module, exports) {

$parcel$export(module.exports, "useCopyToClipboard", () => $3551cf4db632cbd5$export$b2199c37e85de4a7);
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};

});


parcelRegister("jooGc", function(module, exports) {

$parcel$export(module.exports, "useCopyContentLinkState", () => $4ca5e403580d1e7d$export$77cd2a2387f7879a);
$parcel$export(module.exports, "useCopyContentLinkActions", () => $4ca5e403580d1e7d$export$c42bcb6cac241c15);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $4ZoIm.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $iFWZA.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $iFWZA.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);

});




parcelRegister("j66nf", function(module, exports) {

$parcel$export(module.exports, "switchToShareDialog", () => $f72b927cf6dfab7c$export$7be45e41397c6649);
/**
 * Switches to the share dialog by clicking the 'share-trigger-btn' element.
 *
 * This function attempts to find the element with the ID 'share-trigger-btn'. This is
 * the ID of the legacy share button in Confluence. This is no longer necessary when the
 * new Unified Share Dialog is released (around Jan 2025 - March 2025).
 */ function $f72b927cf6dfab7c$export$7be45e41397c6649(closeModal) {
    const node = document.getElementById('share-trigger-btn');
    if (node) closeModal(()=>{
        node.click();
    });
}

});

parcelRegister("bF9T9", function(module, exports) {

$parcel$export(module.exports, "PresenceAvatarButton", () => $f0ec2e1e638ea1ae$export$5baa88db8a182af5);

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $inPa6 = parcelRequire("inPa6");

var $9VtwR = parcelRequire("9VtwR");

var $dv6q2 = parcelRequire("dv6q2");

var $uBose = parcelRequire("uBose");
const $f0ec2e1e638ea1ae$export$5baa88db8a182af5 = ({ index: index, participant: participant, contentMode: contentMode, contentType: contentType, contentId: contentId, isSingleParticipant: isSingleParticipant, toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, avatarProps: avatarProps, analyticSource: analyticSource })=>{
    const { id: id, color: color } = participant;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $dv6q2.useScrollToTelepointer)({
        contentType: contentType,
        contentMode: contentMode,
        // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
        participant: participant
    });
    const getAvatarButtonOnClickHandler = ()=>{
        if (isSingleParticipant) return toggleEmptyPresenceDialog;
        if (isEligibleToScroll) return ()=>{
            const isScrollSuccessful = scrollToTelepointer();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: analyticSource,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'presenceAvatarButton',
                    product: 'confluence',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollSuccessful: isScrollSuccessful
                    }
                }
            }).fire();
        };
        return participant?.onClick;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        padding: "space.025",
        key: `box-${id}`,
        "data-vc": "presence-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $uBose.PresenceAvatar), {
        ...avatarProps,
        src: avatarProps.src,
        name: avatarProps.name,
        activity: participant.activity,
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        key: `avatar-${id}`,
        badgeTextColor: index === 0 ? (0, $9VtwR.getCurrentUserColors)().textColor : (0, $9VtwR.getParticipantColors)(id).textColor,
        borderColor: color ?? index === 0 ? (0, $9VtwR.getCurrentUserColors)().backgroundColor : (0, $9VtwR.getParticipantColors)(id).backgroundColor,
        stackIndex: (0, $9VtwR.MAX_GROUP_SIZE) - index,
        testId: `team-presence-avatar-${index}`,
        onClick: getAvatarButtonOnClickHandler(),
        isEligibleToScroll: isEligibleToScroll,
        isScrollToFeatureEnabled: isScrollToFeatureEnabled
    }));
};

});


parcelRegister("fgzua", function(module, exports) {

$parcel$export(module.exports, "PresenceChangeboarding", () => $c7d04c6396372c0a$export$b11e63743c6002b2);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6cnUO = parcelRequire("6cnUO");
var $1lhEF = parcelRequire("1lhEF");
var $5izcQ = parcelRequire("5izcQ");
var $2Fndw = parcelRequire("2Fndw");

var $inPa6 = parcelRequire("inPa6");

var $ivb8S = parcelRequire("ivb8S");

var $lsxnT = parcelRequire("lsxnT");

var $1BYn9 = parcelRequire("1BYn9");

var $9lC86 = parcelRequire("9lC86");

var $b0XpD = parcelRequire("b0XpD");

var $1XxMr = parcelRequire("1XxMr");
const $c7d04c6396372c0a$export$c6b232dd07adf3e8 = 'https://support.atlassian.com/confluence-cloud/docs/view-a-page/';
const $c7d04c6396372c0a$var$i18n = (0, $2nPZH.defineMessages)({
    spotlightTitle: {
        id: "team-presence.avatar-group.spotlight.title",
        defaultMessage: "{contentType, select, page {See who\u2019s on your page} blogpost {See who\u2019s on your blog post} other {See who\u2019s on your content}}"
    },
    spotlightDescriptionForUsers: {
        id: "team-presence.avatar-group.spotlight.description-user",
        defaultMessage: "{contentType, select, page {You can now see who\u2019s viewing this page in real time.} blogpost {You can now see who\u2019s viewing this blog post in real time.} other {You can now see who\u2019s viewing this content in real time.}}"
    },
    spotlightDescriptionForAdmin: {
        id: "team-presence.avatar-group.spotlight.description-admin",
        defaultMessage: "{contentType, select, page {Your team can now see who\u2019s viewing this page in real time.} blogpost {Your team can now see who\u2019s viewing this blog post in real time.} other {Your team can now see who\u2019s viewing this content in real time.}}"
    },
    spotlightAccessibleLabel: {
        id: "team-presence.avatar-group.spotlight.label",
        defaultMessage: "Onboarding for real-time presence avatar group"
    },
    spotlightPrimaryAction: {
        id: "team-presence.avatar-group.spotlight.primary-action",
        defaultMessage: "OK"
    },
    spotlightSecondaryActionForUsers: {
        id: "team-presence.avatar-group.spotlight.secondary-action-user",
        defaultMessage: "More about visibility"
    },
    spotlightSecondaryActionForAdmin: {
        id: "team-presence.avatar-group.spotlight.secondary-action-admin",
        defaultMessage: "More about settings"
    },
    anonymousUser: {
        id: "team-presence.avatar-group.anonymous-user",
        defaultMessage: "Anonymous Person"
    }
});
const $c7d04c6396372c0a$var$PRESENCE_AVATAR_GROUP_ANALYTIC_SOURCE = 'presenceAvatarGroup';
const $c7d04c6396372c0a$export$b11e63743c6002b2 = ({ children: children, contentId: contentId, contentMode: contentMode, contentType: contentType, totalParticipants: totalParticipants })=>{
    const { isSpotlightEligible: isSpotlightEligible, onboardingStateError: onboardingStateError, onboardingStateLoading: onboardingStateLoading } = (0, $b0XpD.useIsSpotlightEligible)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [isPulseActive, setIsPulseActive] = (0, $gwFzn.useState)(false);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $gwFzn.useState)(false);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPresenceSpotlightClose = (shouldSendAnalytics = false)=>{
        setOnboardingState({
            key: (0, $9lC86.ONBOARDING_PRESENCE_PAGE_STATE_KEYS).PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN,
            value: 'true'
        });
        // we only want to send analytics when the user actively clicked on close
        if (shouldSendAnalytics) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$c7d04c6396372c0a$var$PRESENCE_AVATAR_GROUP_ANALYTIC_SOURCE}Spotlight`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceSpotlightClose',
                attributes: {
                    isProductAdmin: isProductAdmin
                }
            }
        }).fire();
        setIsSpotlightActive(false);
    };
    const onLearnMore = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$c7d04c6396372c0a$var$PRESENCE_AVATAR_GROUP_ANALYTIC_SOURCE}Spotlight`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceSpotlightLearnMore',
                attributes: {
                    isProductAdmin: isProductAdmin
                }
            }
        }).fire();
        onPresenceSpotlightClose(false);
    };
    const onPulseClick = ()=>{
        if (!isPulseActive) return;
        setIsPulseActive(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$c7d04c6396372c0a$var$PRESENCE_AVATAR_GROUP_ANALYTIC_SOURCE}Pulse`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presencePulse',
                attributes: {
                    isProductAdmin: isProductAdmin
                }
            }
        }).fire();
        setIsSpotlightActive(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $c7d04c6396372c0a$var$PRESENCE_AVATAR_GROUP_ANALYTIC_SOURCE,
                actionSubject: 'PresenceAvatarGroup',
                action: 'spotlight shown',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType
                }
            }
        }).fire();
    };
    (0, $gwFzn.useEffect)(()=>{
        if (!onboardingStateLoading && !onboardingStateError) {
            const shouldPulseSpotlight = contentType !== 'whiteboard' && isSpotlightEligible && contentMode === 'view' && (isProductAdmin || totalParticipants > 1);
            if (shouldPulseSpotlight) {
                setIsPulseActive(true);
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: $c7d04c6396372c0a$var$PRESENCE_AVATAR_GROUP_ANALYTIC_SOURCE,
                        actionSubject: 'PresenceAvatarGroup',
                        action: 'pulse shown',
                        attributes: {
                            contentId: contentId,
                            contentMode: contentMode,
                            contentType: contentType
                        }
                    }
                }).fire();
            }
        } else if (onboardingStateError && !onboardingStateLoading) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $c7d04c6396372c0a$var$PRESENCE_AVATAR_GROUP_ANALYTIC_SOURCE,
                actionSubject: 'PresenceAvatarGroup',
                action: 'pulse failed',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        contentId,
        contentMode,
        contentType,
        isProductAdmin,
        isSpotlightEligible,
        totalParticipants,
        onboardingStateLoading,
        onboardingStateError,
        createAnalyticsEvent
    ]);
    let spotlightDescription = formatMessage($c7d04c6396372c0a$var$i18n.spotlightDescriptionForUsers, {
        contentType: contentType
    });
    let learnMoreButtonText = formatMessage($c7d04c6396372c0a$var$i18n.spotlightSecondaryActionForUsers);
    if (isProductAdmin) {
        spotlightDescription = formatMessage($c7d04c6396372c0a$var$i18n.spotlightDescriptionForAdmin, {
            contentType: contentType
        });
        learnMoreButtonText = formatMessage($c7d04c6396372c0a$var$i18n.spotlightSecondaryActionForAdmin);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "presence-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1lhEF.Pulse), {
        pulse: isPulseActive,
        radius: 3,
        onClick: onPulseClick,
        testId: "presence-pulse",
        "data-vc": "presence-avatar-group-container"
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fndw.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1XxMr))),
        actions: [
            {
                onClick: ()=>onPresenceSpotlightClose(true),
                text: formatMessage($c7d04c6396372c0a$var$i18n.spotlightPrimaryAction),
                testId: 'presence-spotlight-action-ok'
            },
            {
                onClick: onLearnMore,
                text: learnMoreButtonText,
                testId: 'presence-spotlight-action-learn-more',
                href: $c7d04c6396372c0a$export$c6b232dd07adf3e8,
                target: '_blank'
            }
        ],
        heading: formatMessage($c7d04c6396372c0a$var$i18n.spotlightTitle, {
            contentType: contentType
        }),
        target: "presence-avatar",
        label: formatMessage($c7d04c6396372c0a$var$i18n.spotlightAccessibleLabel),
        key: "presence-avatar-spotlight",
        testId: "presence-avatar-spotlight",
        targetRadius: 3,
        dialogPlacement: "bottom right",
        shouldWatchTarget: true
    }, spotlightDescription)));
};

});
parcelRegister("9lC86", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_PRESENCE_PAGE_STATE_KEYS", () => $30345a1bb3887a17$export$2fc66944d8ac2f6c);
const $30345a1bb3887a17$export$2fc66944d8ac2f6c = {
    PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN: 'page:pagePresenceAvatarGroupSpotlightSeen'
};

});

parcelRegister("b0XpD", function(module, exports) {

$parcel$export(module.exports, "useIsSpotlightEligible", () => $9098c5d0cc4ba728$export$cff98847d819472);

var $gwFzn = parcelRequire("gwFzn");

var $8Lx5S = parcelRequire("8Lx5S");

var $1ytiN = parcelRequire("1ytiN");

var $ivb8S = parcelRequire("ivb8S");

var $9lC86 = parcelRequire("9lC86");
const $9098c5d0cc4ba728$export$cff98847d819472 = ()=>{
    const { isNewUser: isNewUser } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isEligible = !isNewUser && (isLicensed || isGuest);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $9lC86.ONBOARDING_PRESENCE_PAGE_STATE_KEYS).PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN);
    const { pagePresenceAvatarGroupSpotlightSeen: pagePresenceAvatarGroupSpotlightSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
    (0, $gwFzn.useEffect)(()=>{
        if (!isEligible) setOnboardingState({
            key: (0, $9lC86.ONBOARDING_PRESENCE_PAGE_STATE_KEYS).PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN,
            value: 'true'
        });
    }, [
        isEligible,
        setOnboardingState
    ]);
    return {
        isSpotlightEligible: !pagePresenceAvatarGroupSpotlightSeen && isEligible,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError
    };
};

});

parcelRegister("1XxMr", function(module, exports) {
module.exports = new URL("presence-spotlight-img.9b9958c6.png", import.meta.url).toString();

});


parcelRegister("bLjbS", function(module, exports) {

$parcel$export(module.exports, "usePresence", () => $b722e8b54e461776$export$2a8c16d82a0a0e26);

var $gwFzn = parcelRequire("gwFzn");

var $hvdlr = parcelRequire("hvdlr");

var $jXpbL = parcelRequire("jXpbL");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $7Sm4c = parcelRequire("7Sm4c");

var $lkApp = parcelRequire("lkApp");

var $9VtwR = parcelRequire("9VtwR");

var $5gaYz = parcelRequire("5gaYz");

var $k9TfW = parcelRequire("k9TfW");

var $9UaSY = parcelRequire("9UaSY");
const $b722e8b54e461776$var$MAX_FETCH_SIZE = 25;
const $b722e8b54e461776$export$2a8c16d82a0a0e26 = (contentId, contentType, contentMode, activity)=>{
    const shouldCreatePresenceConnection = contentMode === 'view';
    const [{ collabEditInitialized: collabEditInitialized, collabEditProvider: collabEditProvider }] = (0, $jXpbL.useNativeCollabState)();
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const { add: add, remove: remove, addTelepointerData: addTelepointerData } = (0, $lkApp.usePresenceStoreActions)();
    const participants = (0, $lkApp.useParticipants)();
    const { cloudId: cloudId, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const sessions = (0, $gwFzn.useRef)(new Set());
    const providerRef = (0, $gwFzn.useRef)(collabEditProvider);
    const presenceIdRef = (0, $gwFzn.useRef)(presenceId);
    // really for testing purposes
    const [isInitialized, setIsInitialized] = (0, $gwFzn.useState)(false);
    const [networkError, setNetworkError] = (0, $gwFzn.useState)(undefined);
    (0, $5gaYz.usePresenceLimiter)({
        contentId: contentId,
        contentType: contentType,
        contentMode: contentMode,
        participants: participants,
        provider: providerRef.current
    });
    const getUsers = isGuest || !isLoggedIn || !isLicensed ? (0, $k9TfW.fetchPresenceAGGUsers) : (0, $9UaSY.fetchPresenceConfluenceUsers);
    const fetchMore = ()=>{
        providerRef.current?.fetchMore({
            fetchSize: $b722e8b54e461776$var$MAX_FETCH_SIZE
        });
    };
    const getTotalParticipants = ()=>{
        const uniqueSet = new Set();
        providerRef.current?.getParticipants().forEach((p)=>uniqueSet.add(p.presenceId));
        return uniqueSet.size;
    };
    const handleOnFetchError = (error)=>{
        // want to prevent an infinite spam of api calls being made
        setNetworkError(error);
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    const handleOnPresence = (0, $gwFzn.useCallback)(()=>{
        const people = providerRef.current?.getParticipants().filter((p)=>p.isHydrated);
        people?.forEach((participant)=>{
            sessions.current.add(participant.sessionId);
            add(participant);
        });
        const participantSessions = people?.map((p)=>p.sessionId) ?? [];
        // getParticipants returns all active users, so need to determine which ones to remove
        sessions.current.forEach((sessionId)=>{
            if (!participantSessions.includes(sessionId)) {
                remove(sessionId);
                sessions.current.delete(sessionId);
            }
        });
    }, // don't let this depend on anything with frequent state changes to avoid unnecessary subscriptions and un-subscriptions of the event handling
    [
        add,
        remove
    ]);
    const initializeProvider = (0, $gwFzn.useCallback)(()=>{
        const permissionTokenRefresh = (0, $jXpbL.fetchCollabPermissionToken)(contentId, undefined);
        const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
        // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
        // This means that anonymous users will still rely on presenceId and not get deduplicated.
        const collaboratorPresenceId = userId ?? presenceIdRef.current;
        const provider = (0, $hvdlr.createSocketIOCollabProvider)({
            url: (0, $9VtwR.getPresenceServiceUrl)(),
            documentAri: documentAri,
            permissionTokenRefresh: permissionTokenRefresh,
            need404: true,
            isPresenceOnly: true,
            productInfo: {
                product: 'confluence',
                subProduct: 'team-presence'
            },
            batchProps: {
                batchSize: $b722e8b54e461776$var$MAX_FETCH_SIZE,
                participantsLimit: (0, $9VtwR.MAX_GROUP_SIZE) + 1,
                getUsers: getUsers,
                onError: handleOnFetchError
            },
            presenceId: collaboratorPresenceId,
            presenceActivity: 'viewer'
        });
        // Since we moved to only creating a presence connection on view pages, we should always be a viewer
        provider.setupForPresenceOnly((0, $9VtwR.getPresenceClientId)());
        providerRef.current = provider;
        setIsInitialized(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId,
        contentId,
        contentType
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldCreatePresenceConnection) initializeProvider();
        else setIsInitialized(true);
        // When we don't have a provider and we are not creating a presence connection,
        // we should use the existing collabEditProvider, there was an edge case where this provider wasn't
        // available on the first render.
        if (!providerRef.current && collabEditProvider) providerRef.current = collabEditProvider;
        providerRef.current?.on('presence', handleOnPresence);
        providerRef.current?.on('presence:changed', handleOnPresence);
        providerRef.current?.on('telepointer', addTelepointerData);
        return ()=>{
            providerRef.current?.off('presence', handleOnPresence);
            providerRef.current?.off('presence:changed', handleOnPresence);
            providerRef.current?.off('telepointer', addTelepointerData);
            // we do not want to destroy the live connection, since we didn't create it
            if (shouldCreatePresenceConnection) providerRef.current?.destroy();
        };
    }, [
        addTelepointerData,
        collabEditProvider,
        shouldCreatePresenceConnection,
        initializeProvider,
        handleOnPresence
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldCreatePresenceConnection || !collabEditInitialized) return;
        providerRef.current?.sendMessage({
            type: 'participant:activity',
            activity: activity
        });
    }, [
        activity,
        collabEditInitialized,
        shouldCreatePresenceConnection
    ]);
    (0, $gwFzn.useEffect)(()=>{
        presenceIdRef.current = presenceId;
    }, [
        presenceId
    ]);
    return {
        isInitialized: isInitialized,
        presenceId: presenceId,
        // want to return DUMMY as a default to preserve activity lookup if provider isn't available yet
        sessionId: providerRef.current?.getSessionId() ?? (0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID),
        fetchMore: fetchMore,
        networkError: networkError,
        totalParticipants: getTotalParticipants()
    };
};

});
parcelRegister("k9TfW", function(module, exports) {

$parcel$export(module.exports, "fetchPresenceAGGUsers", () => $aed2f5bf61ddaaa1$export$9db34321b84dd37a);
/** @graphql agg **/ 
var $d2LG0 = parcelRequire("d2LG0");

var $gKr8t = parcelRequire("gKr8t");
const $aed2f5bf61ddaaa1$export$9db34321b84dd37a = (accountIds)=>{
    return (0, $gKr8t.getAGGClient)().query({
        query: (0, $d2LG0.default)`query fetchPresenceAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId || ''
            })) ?? [];
    });
};

});

parcelRegister("9UaSY", function(module, exports) {

$parcel$export(module.exports, "fetchPresenceConfluenceUsers", () => $9cba87adb0d6c766$export$bf12d28b3016b36b);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");

var $hp2SH = parcelRequire("hp2SH");

var $l8FG6 = parcelRequire("l8FG6");
const $9cba87adb0d6c766$export$bf12d28b3016b36b = (accountIds)=>{
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $d2LG0.default)`query fetchPresenceConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{profilePicture{isDefault path(type:RELATIVE)}...on KnownUser{accountId}...on UnknownUser{accountId}displayName permissionType}}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user?.profilePicture?.path ?? '',
                email: '',
                isGuest: (user?.permissionType === (0, $l8FG6.SitePermissionType).EXTERNAL) ?? undefined,
                name: user?.displayName ?? '',
                userId: user?.accountId ?? ''
            })) ?? [];
    });
};

});
parcelRegister("l8FG6", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $9dbb8a2240011757$export$8995abb8169b2cb8);
/**
 * @generated SignedSource<<ea6b8de4e1fa15eaedf478f2b49e4bad>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $9dbb8a2240011757$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});




parcelRegister("lx2Vu", function(module, exports) {

$parcel$export(module.exports, "CanvasPresence", () => $09642762dd72a71c$export$4232d0c4c5b2a438);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $jXpbL = parcelRequire("jXpbL");

var $6S5EB = parcelRequire("6S5EB");

var $lkApp = parcelRequire("lkApp");

var $aC5ZO = parcelRequire("aC5ZO");

var $fgzua = parcelRequire("fgzua");
// don't have activity for canvas, just default to viewer
const $09642762dd72a71c$var$ACTIVITY = 'viewer';
const $09642762dd72a71c$var$CONTENT_MODE = 'view';
const $09642762dd72a71c$export$4232d0c4c5b2a438 = ({ collaborators: collaborators, contentId: contentId, contentType: contentType, analyticSource: analyticSource })=>{
    const initialParticipants = (0, $lkApp.useParticipants)();
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const createOnClickHandler = (collaborator)=>{
        return collaborator.followCursor === true ? ()=>{
            collaborator.onClick?.();
        } : collaborator.onClick;
    };
    /**
	 * If we're not on an external route, get the current cached user; otherwise, wait for current user to come from canvas websocket
	 * Here's a more in-depth explanation
	 *
	 * isExternal = on a public link
	 * At this time external routes aren’t SSRd so we can’t preload. As a result, our user won't be cached
	 *
	 * The possible solutions are
	 * - Get external pages to be SSRd (which was too heavy of a lift at this time of implementation)
	 * - Add photos to the existing user call in SessionDataQuery or SiteInformationQuery
	 * - Just wait for collaborators to come in from websocket connection (which is the current implementation)
	 * right now, we have issues until we can preload users on external routes so don't worry about showing current user before socket connection establishes
	 * we could ad a preloader for external routes; however, external pages don't appeared to be SSRd.
	 *
	 * @param isExternal true if we're on an /external route, otherwise false
	 * @param collaborators list that comes from canvas websocket connection
	 * @returns current user from cache or canvas. Otherwise return undefined
	 */ const getCurrentUser = (0, $gwFzn.useCallback)((collaborators)=>{
        if (isExternal && collaborators?.me) {
            const { me: me } = collaborators;
            //userId from canvas will already be unidentified if user is anonymous and can't be null
            return {
                id: me.userId,
                userId: me.userId,
                name: me.name,
                color: me.color,
                src: me.avatar.src ?? '',
                onClick: createOnClickHandler(me),
                followCursor: me.followCursor,
                activity: $09642762dd72a71c$var$ACTIVITY
            };
        } else if (!isExternal) {
            const currentParticipantId = userId ?? presenceId;
            const currentParticipant = currentParticipantId ? initialParticipants.get(currentParticipantId) : undefined;
            // always want to use the currentParticipant instead of waiting for "me" from collaborators for better performance
            if (currentParticipant) return {
                id: currentParticipant.id,
                userId: currentParticipant.userId,
                src: currentParticipant.src,
                name: currentParticipant.name,
                isGuest: currentParticipant.isGuest,
                activity: $09642762dd72a71c$var$ACTIVITY
            };
        }
        return undefined;
    }, [
        isExternal,
        initialParticipants,
        presenceId,
        userId
    ]);
    const participants = (0, $gwFzn.useMemo)(()=>{
        const result = [];
        const currentUser = getCurrentUser(collaborators);
        if (currentUser) result.push(currentUser);
        collaborators?.collaborators?.forEach((collaborator)=>{
            const id = collaborator.userId;
            result.push({
                id: id,
                userId: id,
                name: collaborator.name,
                color: collaborator.color,
                src: collaborator.avatar.src ?? '',
                // we don't have activities on canvas, right now we need to default to viewer as downstream components depend on activity being present
                activity: $09642762dd72a71c$var$ACTIVITY,
                onClick: createOnClickHandler(collaborator),
                followCursor: collaborator.followCursor
            });
        });
        return result;
    }, [
        collaborators,
        getCurrentUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fgzua.PresenceChangeboarding), {
        contentId: contentId,
        contentMode: $09642762dd72a71c$var$CONTENT_MODE,
        contentType: contentType,
        totalParticipants: participants.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aC5ZO.PresenceAvatarGroup), {
        contentId: contentId,
        contentMode: $09642762dd72a71c$var$CONTENT_MODE,
        contentType: contentType,
        analyticSource: analyticSource,
        onLoadMoreClick: ()=>{},
        participants: participants,
        totalParticipants: participants.length
    }));
};

});


parcelRegister("9NwnH", function(module, exports) {

$parcel$export(module.exports, "rebaseSteps", () => $c4b7da7a59ba31a1$export$bced9e015fcf3afa);
$parcel$export(module.exports, "collab", () => $c4b7da7a59ba31a1$export$995d9de96d1b2e26);
$parcel$export(module.exports, "getDocBeforeUnconfirmedSteps", () => $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e);
$parcel$export(module.exports, "syncFromAnotherSource", () => $c4b7da7a59ba31a1$export$852bd88de4de2d35);
$parcel$export(module.exports, "receiveTransaction", () => $c4b7da7a59ba31a1$export$7581d8ca0d559ec6);
$parcel$export(module.exports, "sendableSteps", () => $c4b7da7a59ba31a1$export$4da2109e7644e6c2);
$parcel$export(module.exports, "getCollabState", () => $c4b7da7a59ba31a1$export$971539697c176258);

var $9HkI0 = parcelRequire("9HkI0");

var $7T7aA = parcelRequire("7T7aA");

var $iu6m9 = parcelRequire("iu6m9");

var $5jGZY = parcelRequire("5jGZY");
class $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c4b7da7a59ba31a1$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $5jGZY.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c4b7da7a59ba31a1$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c4b7da7a59ba31a1$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)// Filter out the analytics steps, they don't need to be sent to the collab service
    // Commented out because it broke undo behaviour
    // TODO: ED-26957 - Figure out how it broke undo
    // if (transform.steps[i] instanceof AnalyticsStep) {
    //   continue;
    // }
    result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c4b7da7a59ba31a1$var$collabKey = new (0, $7T7aA.PluginKey)('collab');
function $c4b7da7a59ba31a1$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $9HkI0.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $7T7aA.Plugin)({
        key: $c4b7da7a59ba31a1$var$collabKey,
        state: {
            init: ()=>new $c4b7da7a59ba31a1$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($c4b7da7a59ba31a1$var$collabKey);
                if (newState) {
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) return new $c4b7da7a59ba31a1$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $c4b7da7a59ba31a1$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($c4b7da7a59ba31a1$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $c4b7da7a59ba31a1$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $c4b7da7a59ba31a1$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    tr.setSelection((0, $7T7aA.TextSelection).create(tr.doc, Math.min(tr.mapping.map(from), tr.doc.nodeSize), Math.min(tr.mapping.map(to), tr.doc.nodeSize)));
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    return tr.setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, newUnconfirmed));
}
function $c4b7da7a59ba31a1$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c4b7da7a59ba31a1$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $7T7aA.TextSelection)) {
        tr.setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, newCollabState);
}
function $c4b7da7a59ba31a1$export$4da2109e7644e6c2(state) {
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $c4b7da7a59ba31a1$export$971539697c176258(state) {
    return $c4b7da7a59ba31a1$var$collabKey.getState(state);
}

});
parcelRegister("5jGZY", function(module, exports) {

$parcel$export(module.exports, "mapStep", () => $33dcd085767efb3e$export$798cdecdcbbf9755);

var $lTYwY = parcelRequire("lTYwY");

var $kviC1 = parcelRequire("kviC1");

var $4FvAQ = parcelRequire("4FvAQ");
// Iterate from the specified starting index down to 0
const $33dcd085767efb3e$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $lTYwY.AnalyticsStep))) return i;
    }
};
const $33dcd085767efb3e$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $33dcd085767efb3e$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $33dcd085767efb3e$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $33dcd085767efb3e$var$isReplaceTypeStep = (step)=>step instanceof (0, $4FvAQ.ReplaceStep);
const $33dcd085767efb3e$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $33dcd085767efb3e$var$isReplaceTypeStep(previousRebaseableStep.step) && $33dcd085767efb3e$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $33dcd085767efb3e$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$33dcd085767efb3e$var$isReplaceTypeStep(previousStep) || mapped && !$33dcd085767efb3e$var$isReplaceTypeStep(mapped) || !mapped) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $33dcd085767efb3e$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $4FvAQ.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $kviC1.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $4FvAQ.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $33dcd085767efb3e$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}

});



//# sourceMappingURL=ContentHeaderPresence.25810fd1.js.map
